import React, { Component } from 'react';
import logo from '../images/logo.svg';

export default class Footer extends Component {
    render() {
        return (
            <footer className="footer">
                <div className="ft-main container">
                    <div className="ft-brand">
                        <img src={logo} alt="Easybank's logo" />
                        <div>
                            l
                        </div>
                    </div>

                    <div className="ft-menu">
                        <ul>
                            <li><a href="#">About Us</a></li>
                            <li><a href="#">Contact</a></li>
                            <li><a href="#">Blog</a></li>
                        </ul>
                    </div>

                    <div className="ft-menu">
                        <ul>
                            <li><a href="#">Careers</a></li>
                            <li><a href="#">Support</a></li>
                            <li><a href="#">Privacy Policy</a></li>
                        </ul>
                    </div>

                    <div className="ft-invite">
                        <button type="button" className="ft-btn">Request Invite</button>
                        <p className="ft-copy">&copy; Easybank. All Rights Reserved</p>
                    </div>

                </div>
            </footer>
        );
    };
}
